import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/little_love_nature_logo.png";
import { Link, useNavigate } from "react-router-dom";
// *** MODIFIED: Added faSearch icon ***
import {
  faAngleDown,
  faUser,
  faXmark,
  faBars,
  faBagShopping,
  faHeart,
  faRightToBracket,
  faSearch, // <-- ADDED THIS ICON
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api } from "../../Constant";
import axios from "axios";
import Popup from "../RegisterScreen/Popup";
import { useLocation } from "react-router-dom";

function Header({ cartRefresh }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [type, setType] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [combinedResults, setCombinedResults] = useState([]);
  const [cartqty, setCartqty] = useState(0);
  const [categorylist, setCategorylist] = useState([]);
  const [username, setUsername] = useState("");
  const [stickyClass, setStickyClass] = useState("");
  const [isUserVisible, setisUserVisible] = useState(false);
  
  // *** MODIFIED: Added state for search visibility ***
  const [isSearchVisible, setIsSearchVisible] = useState(false);


  useEffect(() => {
    const userName = localStorage.getItem("userName");
    const hasShownPopup = localStorage.getItem("hasShownPopup");
    if (userName && location.pathname === "/" && !hasShownPopup) {
      setPopupMessage(`Welcome, ${userName}!`);
      setPopupVisible(true);
      setTimeout(() => {
        setPopupVisible(false);
        localStorage.setItem("hasShownPopup", "true");
      }, 300);
    }
  }, [location]);

  useEffect(() => {
    const stickNavbar = () => {
      if (window !== undefined) {
        let windowHeight = window.scrollY;
        setStickyClass(windowHeight > 70 ? "sticky is-sticky" : "");
      }
    };
    window.addEventListener("scroll", stickNavbar);
    return () => window.removeEventListener("scroll", stickNavbar);
  }, []);

  useEffect(() => {
    axios
      .post(api + "category_list")
      .then((response) => {
        if (response.data.success === "true") {
          setCategorylist(response.data.category);
        }
      })
      .catch((error) => console.log("Error fetching categories:", error));
  }, []);

  useEffect(() => {
    const updateUsername = () => {
      setUsername(localStorage.getItem("userName") || "");
    };
    updateUsername();
    window.addEventListener("storage", updateUsername);
    return () => window.removeEventListener("storage", updateUsername);
  }, []);

  useEffect(() => {
    const currentUsername = localStorage.getItem("userName");
    const currentUserId = localStorage.getItem("userId");
    const currentGuestId = localStorage.getItem("guest_id");
    let payload = null;

    if (currentUserId && currentUsername && currentUsername !== "Guest") {
      payload = { user_id: currentUserId };
    } else if (currentGuestId) {
      payload = { guest_id: currentGuestId };
    }

    if (payload) {
      axios
        .post(api + "cart_list", payload)
        .then((response) => {
          setCartqty(
            response.data.success === "true"
              ? response.data.product?.length || 0
              : 0
          );
        })
        .catch((error) => {
          console.log("Error fetching cart:", error);
          setCartqty(0);
        });
    } else {
      setCartqty(0);
    }
  }, [cartRefresh, username]);

  const handleClosePopup = () => setPopupVisible(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const userClick = () => setisUserVisible(!isUserVisible);

  const handleProfileClick = () => {
    if (username) navigate("/myprofile");
    else navigate("/Login-Page");
  };

  const Wishlistpage = () => {
    const currentUserId = localStorage.getItem("userId");
    const guestId = localStorage.getItem("guest_id");

    if (currentUserId && username && username !== "Guest") {
      navigate(`/wishlist?user_id=${currentUserId}`);
    } else if (guestId) {
      navigate(`/wishlist?guest_id=${guestId}`);
    } else {
      setPopupMessage(
        "Please log in or continue as a guest to view your wishlist."
      );
      setType("loginOrGuest");
      setPopupVisible(true);
    }
  };

  const shopingcart = () => {
    if (username) {
      navigate("/shoping-cart");
    } else {
      setPopupMessage("Please log in or continue as a guest to view your cart.");
      setType("loginOrGuest");
      setPopupVisible(true);
    }
  };

  const handleGuestCartLogin = async () => {
    setPopupVisible(false);
    const storedGuestId = localStorage.getItem("guest_id");
    if (storedGuestId) {
      navigate("/shoping-cart");
      return;
    }

    try {
      const response = await axios.get(api + "get_guest_id");
      const data = response.data;
      if (data.success === true || data.success === "true") {
        const newGuestId = data.guest_id.toString();
        localStorage.setItem("guest_id", newGuestId);
        localStorage.setItem("userName", "Guest");
        localStorage.removeItem("userId");

        window.dispatchEvent(new Event("storage"));
        navigate("/shoping-cart");
      } else {
        setPopupMessage(data.message || "Unable to log in as Guest.");
        setPopupVisible(true);
        setType("error");
      }
    } catch (error) {
      setPopupMessage("An error occurred during guest login.");
      setPopupVisible(true);
      setType("error");
      console.error("Guest login error:", error);
    }
  };

  const handleNavigateToLogin = () => {
    setPopupVisible(false);
    navigate("/Login-Page");
  };

  const handleInputChange = async (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.trim() === "") {
      setCombinedResults([]);
      return;
    }
    try {
      const response = await axios.post(api + "search_key_word", {
        key_word: term,
      });
      if (response.data.success === "true") {
        const products = response.data.search_key_word.product || [];
        const categories = response.data.search_key_word.category || [];
        const combined = [
          ...products.map((item) => ({ ...item, type: "product" })),
          ...categories.map((item) => ({ ...item, type: "category" })),
        ];
        setCombinedResults(combined);
      } else {
        setCombinedResults([]);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
      setCombinedResults([]);
    }
  };
  
  // *** MODIFIED: Toggles search visibility ***
  const toggleSearch = (e) => {
    e.preventDefault();
    setIsSearchVisible(!isSearchVisible);
  };

  return (
    <header className={`header ${stickyClass}`}>
      <div className="container-fluid mx-auto">
        <Link to="/" className="logo-a">
          <img src={Logo} alt="Little Love Nature Logo" className="logo" />
        </Link>
        <nav className={`nav-links ${isOpen ? "open" : ""}`}>
          {categorylist.map((item) => (
            <div key={item.category_id} className="nav-category">
              <Link
                to={
                  item.subcategory && item.subcategory.length > 0
                    ? `/subcategory/${item.category_id}`
                    : `/category-page/${item.category_id}`
                }
                className="category-link"
              >
                {item.category_name}
                {item.subcategory && item.subcategory.length > 0 && (
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="dropdown-icon ms-1"
                  />
                )}
              </Link>
              {item.subcategory && item.subcategory.length > 0 && (
                <div className="dropdown">
                  {item.subcategory.map((sub) => (
                    <Link
                      key={sub.subcategory_id}
                      to={`/subcategory-detail/${sub.subcategory_id}`}
                      className="dropdown-item"
                    >
                      {sub.subcategory_slug_name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div
            className="icon-box icon_box_mobile"
            style={{ padding: "0.5rem", flexDirection: "column-reverse" }}
          >
            {username ? (
              <Link to="/myprofile" className="loginName">
                <h6>
                  <FontAwesomeIcon icon={faUser} /> Welcome, {username}
                </h6>
              </Link>
            ) : (
              <Link to="/Login-Page">
                <FontAwesomeIcon icon={faUser} /> Account
              </Link>
            )}

            <a
              className="mob-wishlist"
              onClick={Wishlistpage}
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faHeart} /> Wishlist
            </a>

            <br />

            <a
              onClick={shopingcart}
              className="shopping-head-main mt-4"
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faBagShopping} /> Cart
              {username && (
                <div className="shopping-count">
                  <span>{cartqty}</span>
                </div>
              )}
            </a>
          </div>
        </nav>
<div className="d-flex">




     <div className="d-flex">
    
        {/* *** MODIFIED: Search icon and absolute positioned input box *** */}
        <div className="head-searchlist mr-3">
          <a href="#" onClick={toggleSearch} className="search-icon-btn">
            <FontAwesomeIcon icon={faSearch} />
          </a>

   <a
  className="d-lg-none mob-wishlist"
  onClick={shopingcart}
  style={{ cursor: "pointer", marginLeft: "10px", marginRight: "10px", color: "#000" }}  // <-- added
>
  <FontAwesomeIcon icon={faBagShopping} />
  {username && <span className="header-cart-count">{cartqty}</span>}
</a>

          
          {isSearchVisible && (
            <div className="search-popup">
              <div className="search_bar">
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={handleInputChange}
                  autoFocus
                />
                <button onClick={() => setIsSearchVisible(false)} className="close-search-btn">
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
              {combinedResults.length > 0 && (
                <div className="combined-results" style={{ height: "150px", overflowY: "auto" }}>
                  {combinedResults.map((item, index) => (
                    <div key={item.id || index} className="result-item">
                      <Link
                        to={item.type === "product" ? `/product-detail/${item.product_id}` : `/category-page/${item.category_id}`}
                        onClick={() => setIsSearchVisible(false)} // Close search on item click
                      >
                        {item.type === "product" ? item.product_name : item.category_name}
                      </Link>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

 

        <div className="icon-box icon_box_web">
          <div className="user-main">
            {username ? (
              <Link to="/myprofile" className="loginName">
                <h6>Welcome, {username}</h6>
              </Link>
            ) : (
              <a href="#" onClick={(e) => { e.preventDefault(); userClick(); }}>
                <FontAwesomeIcon icon={faUser} />
              </a>
            )}
            {isUserVisible && !username && (
              <div className="user-dropdown">
                <div className="account-tit">
                  <p>Do you have an account?</p>
                  <Link to="/Login-Page">Login</Link>
                </div>
                <div className="list-itemuser">
                  <FontAwesomeIcon icon={faUser} />
                  <a style={{ cursor: "pointer" }} onClick={handleProfileClick}>My Profile</a>
                </div>
                <div className="list-itemuser">
                  <FontAwesomeIcon icon={faRightToBracket} />
                  <Link to="/Register-Page">Sign Up</Link>
                </div>
              </div>
            )}
          </div>
          <a
            className="mob-wishlist"
            onClick={Wishlistpage}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faHeart} />
          </a>
          <a
            onClick={shopingcart}
            className="shopping-head-main"
            style={{ cursor: "pointer" }}
          >
            {username && (
              <div className="shopping-count">
                <span>{cartqty}</span>
              </div>
            )}
            <FontAwesomeIcon icon={faBagShopping} />
          </a>
        </div>

   </div>  

        <div className="hamburger" onClick={toggleMenu}>
          {isOpen ? (
            <span className="close-icon">
              <FontAwesomeIcon icon={faXmark} />
            </span>
          ) : (
            <span>
              <FontAwesomeIcon icon={faBars} />
            </span>
          )}
        </div>
</div>
        
      </div>
      {popupVisible && (
        <Popup
          message={popupMessage}
          title={type === "error" ? "Error" : "Notice"}
          type={type}
          onClose={handleClosePopup}
          onGuestContinue={(guestId) => {
            console.log("Guest logged in with ID:", guestId);
            navigate("/shoping-cart");
          }}

          product_id={null}
          addsize={null}
          quantity={null}

          
        />
      )}
    </header>
  );
}

export default Header;